import { render, staticRenderFns } from "./IdentityVerificationDialog.vue?vue&type=template&id=75703da7&scoped=true"
import script from "./IdentityVerificationDialog.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerificationDialog.vue?vue&type=style&index=0&id=75703da7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75703da7",
  null
  
)

export default component.exports